module.exports = function() {
  var result = {};

  for (var prop in this) {
    if (!this.hasOwnProperty(prop) || prop.match(/^(?:include|contains|reverse|join|map|wrap)$/)) continue;
    result[prop] = this[prop];
  }

  return result;
};



//////////////////
// WEBPACK FOOTER
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/node_modules/underscore.string/exports.js
// module id = ../../../../underscore.string/exports.js
// module chunks = polyfills